var _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path6, _path7, _g0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 356,
    viewBox: "0 0 218 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 30,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Networth"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 90,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Goals & Expenses"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 150,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Post Retirement Income"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 205,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Risk Assesment"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 265,
    fill: "#0B2653",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", null, "Asset Allocation"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 325,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Portfolio Construction"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 46,
    x2: 33,
    y2: 68,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 106,
    x2: 33,
    y2: 128,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 164,
    x2: 33,
    y2: 186,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 223,
    x2: 33,
    y2: 245,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 280,
    x2: 33,
    y2: 304,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7C43.598 7 53 16.402 53 28C53 39.598 43.598 49 32 49C20.402 49 11 39.598 11 28C11 16.402 20.402 7 32 7ZM32 46.0802C41.9854 46.0802 50.0802 37.9854 50.0802 28C50.0802 18.0146 41.9854 9.91976 32 9.91976C22.0146 9.91976 13.9198 18.0146 13.9198 28C13.9198 37.9854 22.0146 46.0802 32 46.0802Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66C43.598 66 53 75.402 53 87C53 98.598 43.598 108 32 108C20.402 108 11 98.598 11 87C11 75.402 20.402 66 32 66ZM32 105.08C41.9854 105.08 50.0802 96.9854 50.0802 87C50.0802 77.0146 41.9854 68.9198 32 68.9198C22.0146 68.9198 13.9198 77.0146 13.9198 87C13.9198 96.9854 22.0146 105.08 32 105.08Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 125C43.598 125 53 134.402 53 146C53 157.598 43.598 167 32 167C20.402 167 11 157.598 11 146C11 134.402 20.402 125 32 125ZM32 164.08C41.9854 164.08 50.0802 155.985 50.0802 146C50.0802 136.015 41.9854 127.92 32 127.92C22.0146 127.92 13.9198 136.015 13.9198 146C13.9198 155.985 22.0146 164.08 32 164.08Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 184C43.598 184 53 193.402 53 205C53 216.598 43.598 226 32 226C20.402 226 11 216.598 11 205C11 193.402 20.402 184 32 184ZM32 223.08C41.9854 223.08 50.0802 214.985 50.0802 205C50.0802 195.015 41.9854 186.92 32 186.92C22.0146 186.92 13.9198 195.015 13.9198 205C13.9198 214.985 22.0146 223.08 32 223.08Z",
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 243C34.7578 243 37.4885 243.543 40.0364 244.599C42.5842 245.654 44.8992 247.201 46.8492 249.151C48.7993 251.101 50.3461 253.416 51.4015 255.964C52.4568 258.511 53 261.242 53 264H50.0802C50.0802 261.626 49.6126 259.275 48.704 257.081C47.7953 254.887 46.4636 252.894 44.7847 251.215C43.1058 249.536 41.1126 248.205 38.919 247.296C36.7254 246.387 34.3743 245.92 32 245.92L32 243Z",
    fill: "#4081BD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_210_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 16,
    fill: "#27AE60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 31.6978L25.6258 28.3865C25.2534 28.0143 24.6517 28.0143 24.2793 28.3865C23.9069 28.7586 23.9069 29.3598 24.2793 29.732L28.271 33.7209C28.6434 34.093 29.245 34.093 29.6174 33.7209L39.7207 23.6247C40.0931 23.2525 40.0931 22.6513 39.7207 22.2791C39.3483 21.907 38.7466 21.907 38.3742 22.2791L28.9394 31.6978Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_210_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87,
    r: 16,
    fill: "#27AE60"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_210_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 90.6978L25.6258 87.3865C25.2534 87.0143 24.6517 87.0143 24.2793 87.3865C23.9069 87.7586 23.9069 88.3598 24.2793 88.732L28.271 92.7209C28.6434 93.093 29.245 93.093 29.6174 92.7209L39.7207 82.6247C40.0931 82.2525 40.0931 81.6513 39.7207 81.2791C39.3483 80.907 38.7466 80.907 38.3742 81.2791L28.9394 90.6978Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_210_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 146,
    r: 16,
    fill: "#27AE60"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_210_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 149.698L25.6258 146.386C25.2534 146.014 24.6517 146.014 24.2793 146.386C23.9069 146.759 23.9069 147.36 24.2793 147.732L28.271 151.721C28.6434 152.093 29.245 152.093 29.6174 151.721L39.7207 141.625C40.0931 141.252 40.0931 140.651 39.7207 140.279C39.3483 139.907 38.7466 139.907 38.3742 140.279L28.9394 149.698Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_210_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 205,
    r: 16,
    fill: "#27AE60"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_210_281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 208.698L25.6258 205.386C25.2534 205.014 24.6517 205.014 24.2793 205.386C23.9069 205.759 23.9069 206.36 24.2793 206.732L28.271 210.721C28.6434 211.093 29.245 211.093 29.6174 210.721L39.7207 200.625C40.0931 200.252 40.0931 199.651 39.7207 199.279C39.3483 198.907 38.7466 198.907 38.3742 199.279L28.9394 208.698Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_210_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 264,
    r: 16,
    fill: "#4081BD"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5559 261.937C38.1502 260.606 37.3455 259.466 36.2268 258.633L32.5996 263.755L38.4679 265.98C38.9316 264.664 38.9621 263.268 38.556 261.937L38.5559 261.937Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4826 264.112L31.4653 264.097C31.4486 264.078 31.4366 264.057 31.4295 264.034C31.4146 263.986 31.4232 263.932 31.4531 263.889L35.2042 258.592C35.0212 258.47 34.8306 258.355 34.6354 258.251C33.6929 257.75 32.6391 257.484 31.5877 257.484C30.9487 257.484 30.3109 257.58 29.6921 257.769C28.0314 258.276 26.6676 259.399 25.8516 260.931C25.0357 262.464 24.8654 264.222 25.3719 265.883C25.8786 267.544 27.0017 268.907 28.5342 269.724C29.475 270.225 30.5281 270.489 31.5804 270.489C32.2224 270.489 32.8638 270.393 33.4861 270.203C35.3611 269.631 36.8561 268.264 37.5998 266.444L31.511 264.133C31.4973 264.126 31.488 264.118 31.4824 264.113L31.4826 264.112Z",
    fill: "white"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_210_281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 320,
    r: 16,
    fill: "#A85CD7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 315.162H35.8001V313.296C35.8001 312.929 35.5001 312.629 35.1335 312.629H28.6001C28.2334 312.629 27.9334 312.929 27.9334 313.296V315.162H25C24.4334 315.162 24 315.629 24 316.162V318.729H40V316.162C40 315.629 39.5666 315.162 39 315.162H39.0001ZM29.2667 313.962H34.4667V315.162H29.2667V313.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 321.059H36.1V319.859H27.9V321.059H26.2V319.859H24V326.359C24 326.893 24.4334 327.359 25 327.359H39C39.5667 327.359 40 326.893 40 326.359V319.859H37.8V321.059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_210_281",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_210_281",
    x: 0,
    y: 59,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_210_281",
    x: 0,
    y: 118,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_210_281",
    x: 0,
    y: 177,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_210_281",
    x: 0,
    y: 236,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_210_281",
    x: 0,
    y: 292,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_281",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_210_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 77)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_210_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_210_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step_5.f1759ffd7d1e2f70b8d1aafddcbf9f14.svg";
export { ForwardRef as ReactComponent };